import React, { forwardRef } from 'react';
import cn from 'classnames';
import BaseButton from './BaseButton';

const SaveButton = forwardRef(({ title = 'Save', className, ...props }, ref) => {
  const btnClassName = cn('save-button', { [className]: className });
  return (
    <BaseButton
      ref={ref}
      id='save-button'
      responsive
      primary
      type='submit'
      className={btnClassName}
      icon='save'
      title={title}
      {...props}
    />
  );
});

export default SaveButton;
